const tourSteps = [
  {
    target: ".tour-sidebar-process",
    content: "Click here to go to Process Service cases and begin your journey.",
    placement: "right",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-create-case-btn",
    content: "Click this button to start creating a new case.",
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-add-client-btn",
    content: "Click here to add a new client for this case.",
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-save-client-btn",
    content: 'Tour Mode Active! The form is auto-filled. Click "Save Changes" to continue.',
    placement: "top",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  { 
      target: '.tour-intake-submit-btn', 
      content: 'Client selected and form auto-filled! Click "Create New Intake" to finalize the case file.', 
      placement: 'top', 
      disableBeacon: true, 
      spotlightClicks: true,
      hideNextButton: true,
      hideBackButton: true,
      disableScroll: false,
  },
  {
    target: ".tour-view-case-btn",
    content: "Click the View link on your new case to open the case management dashboard.",
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-gps-checkin",
    content: 'Click "Capture Live Location" to simulate a field agent logging their arrival.',
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-start-service",
    content: 'Now click "Start Service (Check-in)" to begin the official log for this servee.',
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-mark-served",
    content: 'Once checked in, click "Mark Served" to finalize the service and enter serving details.',
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-service-details-form",
    content: "The form is auto-filled for this demo! Just upload any dummy file for the 'Final Proof' to continue.",
    placement: "top",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-affidavits-container",
    content: "Once service is recorded, your professional affidavit will appear here. Click to generate/view.",
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-upload-file",
    content: "First, click Choose File to select a document. Then, click Upload File to finish your onboarding!",
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
  {
    target: ".tour-complete-onboarding",
    content: "Great job! Click 'Complete Onboarding' to finalize your trial activation and return to the dashboard.",
    placement: "top",
    disableBeacon: true,
    spotlightClicks: true,
    hideNextButton: true,
    hideBackButton: true,
    disableScroll: false,
  },
];

export default tourSteps;




